import React, { forwardRef } from 'react';
import { Text, TextProps } from '../Text';

/**
 * @deprecated use `HeadingText` from `genesis-core` instead
 */

export const SubtitleTwo = forwardRef<HTMLElement, TextProps>((props, ref) => (
  <Text
    as="h5"
    color="onSurface.text.primary"
    typography="subtitleTwo"
    ref={ref}
    {...props}
  />
));

SubtitleTwo.displayName = 'SubtitleTwo';
